// https://github.com/sindresorhus/query-string
import queryString from 'query-string';

/*
 * Returns an object parsed from the current state of the location.search in the URL
 */
export default queryString.parse(window.location.search);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/queryparams/QueryParamsData.js
// module id = 1075
// module chunks = 0